import React from "react";
import { Typography, Card } from "antd";

const { Paragraph } = Typography;

const InfoComponent = ({ title, description }) => {
  return (
    <Card
      bordered={false}
      style={{
        backgroundColor: "#f0f5ff", // hellblauer Infobereich
        borderLeft: "4px solid #1677ff", // blaue Linie links
        padding: "12px 16px",
        marginBottom: "16px",
        borderRadius: "8px",
      }}
    >
      <Paragraph strong style={{ marginBottom: 4 }}>
        {title}
      </Paragraph>
      <Paragraph style={{ marginBottom: 0 }}>{description}</Paragraph>
    </Card>
  );
};

export default InfoComponent;
